import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FreudMessage, FreudMessageService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import firebase from 'firebase';
import { ExportService } from 'modules/exports/services/export.service';

@Component({
	selector: 'export-modal',
	templateUrl: './export-modal.component.html',
	styleUrls: ['./export-modal.component.scss'],
})
export class ExportModalComponent implements OnInit {
	@Input() isOpen = false;
	@Input() customerId = null;
	@Output() onClose = new EventEmitter();
	public form;
	public reason = null;
	public isLoading = false;
	constructor(
		public exportService: ExportService,
		public messageService: FreudMessageService,
		private translate: TranslateService,
		private router: Router,
		private atTrackers: ActionTrackerService
	) {}

	ngOnInit(): void {
		this.form = new FormGroup({
			reason: new FormControl(''),
			anotherReason: new FormControl('', Validators.minLength(5)),
			password: new FormControl('', [
				Validators.required,
				Validators.minLength(6),
			]),
			terms: new FormControl(false),
		});
	}

	export(isDisabled) {
		if (isDisabled) {
			return;
		}
		if (this.validateForm()) {
			this.isLoading = true;
			this.validatePassword()
				.then(() => {
					this.exportService
						.exportPromptuary({
							reasonDetails: this.form.controls.anotherReason.value,
							reason: this.reason,
							customerId: this.customerId,
						})
						.toPromise()
						.then(() => {
							this.atTrackers.eventTracker(
								SCOPE_TYPE.Promptuary,
								SUBSCOPE_TYPE.Export,
								ITEM_TYPE.BtnSave,
								INTERACTION_TYPE.Success
							);
							this.toast(
								this.translate.instant('EXPORT.INIT_EXPORT_SUCCESS'),
								'success'
							);
							this.close();
						})
						.catch((err) => {
							this.atTrackers.eventTracker(
								SCOPE_TYPE.Promptuary,
								SUBSCOPE_TYPE.Export,
								ITEM_TYPE.BtnSave,
								INTERACTION_TYPE.Error
							);
							this.toast(err.error.messageI18n, 'error');
						});
				})
				.catch(() => {
					this.toast(
						this.translate.instant('EXPORT.INCORRECT_PASSWORD'),
						'error'
					);
				})
				.finally(() => {
					this.isLoading = false;
				});
		}
	}

	validateForm() {
		this.isLoading = true;
		this.form.markAllAsTouched();
		if (!this.form.valid || !this.reason) {
			this.toast(this.translate.instant('EXPORT.VERIFY_FORM_FIELDS'), 'error');
			this.isLoading = false;
			return false;
		}
		if (this.reason === 'another' && !this.form.controls.anotherReason.value) {
			this.toast(
				this.translate.instant('EXPORT.MOTIVE_ANOTHER_TOAST'),
				'error'
			);
			this.isLoading = false;
			return false;
		}
		this.isLoading = false;
		return true;
	}

	validatePassword() {
		const user = firebase.auth().currentUser;
		const credential = firebase.auth.EmailAuthProvider.credential(
			firebase.auth().currentUser.email,
			this.form.controls.password.value
		);

		return user.reauthenticateWithCredential(credential);
	}

	toast(summary, type: 'success' | 'error') {
		const message: FreudMessage = {
			severity: type,
			summary: summary,
			detail: null,
		};
		this.messageService.add(message);
	}

	close() {
		this.form.reset();
		this.onClose.emit();
	}
}
